import { css } from "@emotion/react";
import type { ComponentPropsWithoutRef } from "react";

const headerFooterStyle = css`
  display: none;

  @media print {
    display: block;
    position: fixed;
    left: 10px;
    right: 10px;

    white-space: nowrap;
    overflow-x: hidden;
    text-overflow: ellipsis;
  }
`;

export const PageHeader = (props: { title: string }) => (
  <div
    css={css`
      @media print {
        height: calc(2 * var(--report-root-font-size));
      }
    `}
  >
    <div
      css={[
        headerFooterStyle,
        css`
          @media print {
            top: 0;
          }
        `,
      ]}
    >
      {props.title}
    </div>
  </div>
);

export const PageFooter = (props: { title: string }) => (
  <div
    css={css`
      @media print {
        height: calc(2 * var(--report-root-font-size));
      }
    `}
  >
    <div
      css={[
        headerFooterStyle,
        css`
          @media print {
            bottom: 0;
          }
        `,
      ]}
    >
      {props.title}
    </div>
  </div>
);

export const Page = (props: ComponentPropsWithoutRef<"div">) => (
  <div
    css={css`
      @media print {
        :not(:last-of-type) {
          break-after: page;
        }
      }

      @media screen {
        margin-bottom: 48px;
      }
    `}
    {...props}
  />
);
